module.exports = __webpack_public_path__ + "startpage-746fed5a/step2-f95717ba426d7ad6c4996eaca68b595c.svg";